import styled from "styled-components";
import {Tabs} from "antd";

export const InnerTabsStyles = styled(Tabs)`
  & > .ant-tabs-nav {
    background-color: var(--c-table-header);
    border-bottom: 1px solid var(--c-line);
    margin-bottom: 0;

    .ant-tabs-tab {
      margin: 0;
      padding: 16px 20px;
    }
  }

  & > .ant-tabs-content-holder {
    background-color: #fff;
  }
`